module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.19801/js/img/productIcons/OperationsHub_Ent.svg"